module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "carousel"
  }, [(_vm.images.length > 0) ? _c('div', {
    staticClass: "pictures top-carousel",
    class: 'num-images-' + _vm.images.length
  }, _vm._l((_vm.images), function(img, index) {
    return _c('figure', {
      class: {
        'active': _vm.currIndex === index
      },
      on: {
        "click": function($event) {
          _vm.next()
        }
      }
    }, [(img.picture) ? [_c('vue-picture', {
      attrs: {
        "imgset": img,
        "sizes": _vm.fullSizes,
        "className": img.attributes.className
      }
    })] : [_c('picture', {
      staticClass: "original",
      class: img.attributes.className
    }, [_c('img', {
      attrs: {
        "src": img.sizes.orig,
        "alt": img.attributes.alt,
        "width": img.attributes.width,
        "height": img.attributes.height
      }
    })])], _vm._v(" "), (img.attributes.title) ? _c('figcaption', [_vm._v(_vm._s(img.attributes.title))]) : _vm._e()], 2)
  })) : _vm._e(), _vm._v(" "), (_vm.showNav && _vm.images.length > 1) ? _c('div', {
    staticClass: "arrow prev icon-triangle-prev click-overlay",
    on: {
      "click": function($event) {
        _vm.prev()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showNav && _vm.images.length > 1) ? _c('div', {
    staticClass: "arrow next icon-triangle-next click-overlay",
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showNav && _vm.images.length > 1) ? _c('v-touch', {
    staticClass: "arrow prev touch-overlay",
    attrs: {
      "tag": "div"
    },
    on: {
      "tap": function($event) {
        _vm.prev()
      },
      "swiperight": _vm.prev
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showNav && _vm.images.length > 1) ? _c('v-touch', {
    staticClass: "arrow next touch-overlay",
    attrs: {
      "tag": "div"
    },
    on: {
      "tap": function($event) {
        _vm.next()
      },
      "swipeleft": _vm.next
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showNav && _vm.images.length > 1) ? _c('nav', {
    staticClass: "horizontal circles plain "
  }, [(_vm.images.length > 0) ? _c('ol', _vm._l((_vm.images), function(img, index) {
    return _c('li', {
      class: {
        'active': _vm.currIndex === index
      },
      on: {
        "click": function($event) {
          _vm.setActive(index)
        }
      }
    }, [_vm._v(_vm._s((index + 1)))])
  })) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3e24ecc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueSlideshow.vue
// module id = 51
// module chunks = 0